import * as React from 'react';
// import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Formik, FormikProps } from 'formik';
import { FormInput } from 'common/components/form/FormInput';
import { VoucherApi } from 'common/api/resources/Voucher';
import moment = require('moment');
import { Member } from 'common/api/models/Member';

export interface Day {
  activatedDay: number;
  expiredDay: number;
}
interface NumericDialogProps {
  isOpen: boolean;
  voucher: string;
  onSave: () => void;
  onCancel: () => void;
  error?: string;
  title?: string;
  saveLabel?: string;
  activatedDate?: string;
  expireDate?: string;
  originalExpireDate?: string;
  orderId?: string;
  productId?: string;
  member?: Member;
}
class NumericValues {
  activatedDay = 0;
  expiredDay = 0;
}

export class VoucherEditDialog extends React.Component<NumericDialogProps> {
  // validationSchema = Yup.object().shape({
  //   day: Yup.number().required('Required'),
  // });

  initialValues() {
    // console.log(this.props.activatedDate);
    return {
      expiredDay: 0,
      activatedDay: 0,
    };
  }

  handleSubmit = async (values: NumericValues) => {
    let expireDate = moment(this.props.expireDate)
      .add(values.expiredDay, 'days')
      .toISOString();

    let activatedDate = moment(this.props.activatedDate)
      .add(values.activatedDay, 'days')
      .toISOString();
    // console.log(activatedDate);
    await this.setState({ isLoading: true });
    if (this.props.voucher) {
      VoucherApi.updateVoucher(this.props.voucher, {
        expireDate: expireDate,
        activatedDate: activatedDate,
      })
        .then(() => {
          this.setState({ isLoading: false });
          this.props.onSave();
        })
        .catch(e => {
          this.setState({ isLoading: false });
        });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<NumericValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                <label>Current expiration date: {moment(this.props.expireDate).format('L')}</label>
                <FormInput label="Expired day(s):" name="expiredDay" id="expiredDay" type="number" />
                <label>Current activated date: {moment(this.props.activatedDate).format('L')}</label>
                <FormInput label="Activated day(s):" name="activatedDay" id="activatedDay" type="number" />
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    {this.props.saveLabel ? this.props.saveLabel : 'Save'}
                  </Button>
                </div>
              </ModalFooter>
              {this.props.error && <div className="alert alert-danger">{this.props.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/VoucherEditDialog.tsx